import { tv } from 'tailwind-variants'

import { caption, h5 } from '@ui-kit/core/typography'

export const alert = tv({
  slots: {
    container:
      'flex w-full cursor-pointer flex-row items-center gap-x-2.5 rounded-lg p-4 hover:opacity-70 active:opacity-70 web:transition-opacity web:duration-300 web:ease-in-out',
    textContainer: 'flex-1',
    title: h5(),
    message: caption(),
  },
  variants: {
    variant: {
      error: {
        container: 'bg-ui-red-light',
        title: 'text-ui-red',
        message: 'text-ui-red',
      },
      warning: {
        container: 'bg-ui-orange-light',
        title: 'text-ui-orange',
        message: 'text-ui-orange',
      },
      success: {
        container: 'bg-ui-green-light',
        title: 'text-ui-green',
        message: 'text-ui-green',
      },
    },
  },
})
